// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"426f3709","861":"ba8e234a"}[chunkId] + ".chunk.css";
};